const _temp0 = require("../extended-ani/ani-style.css");

const _temp1 = require("../extended-backgrounds/style.css");
const _temp2 = require("../extended-containers/style.css");
const _temp3 = require("../extended-column/column-style.css");

const _temp4 = require("../extended-hide/hide-style.css");

const _temp5 = require("../extended-list/style.css");
const _temp6 = require("../extended-separator/style.css");
module.exports = {
  "extended-ani":   {
    "ani-": _temp0
  },
  "extended-backgrounds": _temp1,
  "extended-containers": _temp2,
  "extended-column":   {
    "column-": _temp3
  },
  "extended-hide":   {
    "hide-": _temp4
  },
  "extended-list": _temp5,
  "extended-separator": _temp6
}